import { render } from "./electricityStat.vue?vue&type=template&id=6d6c6198&scoped=true"
import script from "./electricityStat.vue?vue&type=script&lang=js"
export * from "./electricityStat.vue?vue&type=script&lang=js"

import "./electricityStat.vue?vue&type=style&index=0&id=6d6c6198&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d6c6198"]])

export default __exports__